// User-configurable Monte-Carlo defaults, persisted in localStorage.
//
// Settings page reads/writes here; toleranceStore reads at boot (and on
// newProject) so a fresh chain starts with the user's preferred sample
// count + confidence level instead of the engine defaults.

import { MC_CONFIDENCE_LEVELS, DEFAULT_SAMPLES, DEFAULT_CONFIDENCE } from './monteCarlo';

export const MC_DEFAULTS_LS_KEY = 'toleranz_mc_defaults';

export function loadMcDefaults() {
  if (typeof localStorage === 'undefined') {
    return { samples: DEFAULT_SAMPLES, confidence: DEFAULT_CONFIDENCE, seed: null };
  }
  try {
    const raw = localStorage.getItem(MC_DEFAULTS_LS_KEY);
    if (!raw) return { samples: DEFAULT_SAMPLES, confidence: DEFAULT_CONFIDENCE, seed: null };
    const parsed = JSON.parse(raw);
    const samples = Number.isFinite(Number(parsed.samples))
      ? Math.max(100, Math.min(500_000, Number(parsed.samples)))
      : DEFAULT_SAMPLES;
    const validConfs = Object.values(MC_CONFIDENCE_LEVELS);
    const confidence = validConfs.includes(parsed.confidence) ? parsed.confidence : DEFAULT_CONFIDENCE;
    // Seed: null → unseeded (Math.random); finite number → deterministic.
    // Stored alongside samples + confidence so Pro users can lock down a
    // reproducible run by default across every new project.
    const seed = parsed.seed == null
      ? null
      : (Number.isFinite(Number(parsed.seed)) ? Number(parsed.seed) : null);
    return { samples, confidence, seed };
  } catch {
    return { samples: DEFAULT_SAMPLES, confidence: DEFAULT_CONFIDENCE, seed: null };
  }
}

export function saveMcDefaults(values) {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(MC_DEFAULTS_LS_KEY, JSON.stringify({
      samples: values.samples,
      confidence: values.confidence,
      seed: values.seed ?? null,
    }));
  } catch { /* ignore */ }
}
